import React from "react";
import { Breadcrumb } from "antd";

const LayoutBreadCrum = (props) => {
  // -------------------------- VAR --------------------------
  const items =
    props?.data?.map((item) => {
      const title = item.title;
      const url = item.url || null;
      return { title: <a href={url}>{title}</a> };
    }) || [];
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- MAIN --------------------------

  return <Breadcrumb className="breadcrumb" items={items} />;
};

export default LayoutBreadCrum;
